<template>
    <div>
        
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="订单号">
                    <el-input size="small" v-model="queryParams.orderId"   @keyup.enter.native="search()" placeholder="订单号" style="width: 120px" />
                </el-form-item>
                <el-form-item label="货运单">
                    <el-input size="small" v-model="queryParams.waybillOrder"  @keyup.enter.native="search()" placeholder="货运单" style="width: 120px" />
                </el-form-item>
                <el-form-item label="快递单号">
                    <el-input size="small" v-model="queryParams.expressNo"  @keyup.enter.native="search()" placeholder="快递单号" style="width: 120px" />
                </el-form-item>
                <el-form-item label="商户名称">
                    <el-input size="small" v-model="queryParams.userName"  @keyup.enter.native="search()" placeholder="商户名称" style="width: 120px" />
                </el-form-item>
               <el-form-item label="状态">
                    <el-select size="small"  v-model="queryParams.state" @change="search()" placeholder="状态" style="width: 120px">
                        <el-option value="" label="全部订单">全部订单</el-option>
                        <el-option value="0" label="待处理">待处理</el-option>
                        <el-option value="1" label="已签收">已签收</el-option>
                        <el-option value="-1" label="已退回">已退回</el-option>
                        <el-option value="-2" label="已取消">已取消</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker size="small" type="daterange" @change="cbtime" v-model="others.btime" placeholder="创建时间" start-placeholder="签收时间"  end-placeholder="截止时间" value-format="yyyy-MM-dd"  style="width: 260px"></el-date-picker>
                </el-form-item>
                <el-form-item label="签收时间">
                    <el-date-picker size="small"  type="daterange" @change="cbstime" v-model="others.bstime" start-placeholder="签收时间"  end-placeholder="截止时间" value-format="yyyy-MM-dd" style="width: 260px"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>
            </el-form>
            <Table :loading="loading" :columns="columns" :data="waybillExpresss" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
        <CWaybillExpressBack :show="showBack" @ok="showBack=false;getList()" @cancel="showBack=false" :state="state" :waybillExpress="waybillExpress"></CWaybillExpressBack>
        <CWaybillExpressRemark :waybillExpress="waybillExpress" :show="showRemark" @ok="remarkOk" @cancel="showRemark=false;"></CWaybillExpressRemark>
        <Modal :title="title" v-model="visible" :width="800">
            <img :src="imgName" v-if="visible" style="width: 100%">
        </Modal>
    </div>
</template>
<script>
import CWaybillExpressBack from '../WaybillExpress/CWaybillExpressBack.vue'
import CWaybillExpressRemark from '../WaybillExpress/CWaybillExpressRemark.vue'
import Constants from '@/utils/constants'
export default {
    name: "CWaybillExpress",
    data() {
        return { showRemark:false,
            loading: false,
            visible: false,
            imgName: "",
            title: "",
            showRemark: false,
            waybillExpress: {},
            waybillExpresss: [],
            showBack: false,
            queryParams: {

            },
            state: 0,
            remark: "",
            others: {},
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 120,
                    align: 'center'
                },{
                    title: '所属货运单',
                    key: 'waybillNo',
                    width: 200,
                    align: 'left',
                    render: (h, params) => {
                        var row = params.row;
                        var divs = [];
                        divs.push(h("div", {}, Constants.getShopType(row.shopId)));
                        divs.push(h("div", {}, "订单号：" + row.waybillOrderId));
                        divs.push(h("div", {}, "运单号：" + row.waybillNo));
                        divs.push(h("div", {}, "商户名：" + row.userName));
                        return h("div", { props: {}, style: {} }, divs);

                    }

                }, {
                    title: '快递',
                    key: 'expressName',
                    width: 160,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var divs = [];
                        if (row.mult == 1) {
                            divs.push(h("div", { style: { color: "#ff0000" } }, "多订单"));
                        }
                        divs.push(h("div", {}, row.expressName));
                       if (row.type == 1)
                            divs.push(h("div", {}, "单号：" + row.expressNo));
                        else divs.push(h("div", {}, "仓库库存"));
                        if (row.wareRemark) {
                            divs.push(h("div", {}, "仓库备注：" + row.wareRemark));
                        }
                        return h("div", { props: {}, style: {} }, divs);

                    }
                }, {
                    title: '商品图片',
                    key: 'outOrderNo',
                    width: 280,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        var row = params.row;
                        var divs = [];
                        var divimages = [];
                        var ps = row.pics.split("##");

                        for (var i = 0; i < ps.length; i++) {

                            if (ps[i] != '') {
                                var imgs = [];
                                imgs.push(h("img", {
                                    style: {},
                                    attrs: { src: ps[i] },
                                    on: {
                                        click: (e) => {

                                            var t = e.currentTarget.currentSrc;
                                            me.imgName = t;
                                            me.title = row.expressName + ":" + row.expressNo;
                                            me.visible = true;
                                        }
                                    }
                                }));
                                divimages.push(h("div", { class: ["demo-upload-list"] }, imgs));
                            }
                        }
                        if (divimages.length > 0) {

                            return h("div", { props: {}, style: { float: "left" } }, divimages);
                        } else {
                            return h("div", { props: {}, style: {} }, "暂无图片");
                        }



                    }
                }, {
                    title: '状态',
                    key: 'state',
                    width: 190,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var spans = [];
                        var me = this;
                        spans.push(h("div", "创建：" + me.long2datetime(params.row.createTime)));

                        var text = "待签收";
                        var styles = { color: '#fff', padding: '2px' };
                        styles.backgroundColor = "#2db7f5";
                        if (row.state == -2) {
                            text = "已取消";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "取消：" + me.long2datetime(params.row.cancelTime)));
                        } else if (row.state == 1) {
                            text = "已签收";
                            styles.backgroundColor = "#19be6b";
                            spans.push(h("div", "签收：" + me.long2datetime(params.row.signTime)));
                        } else if (row.state == -1) {
                            text = "拒签退回";
                            styles.backgroundColor = "#ed4014";
                            spans.push(h("div", "退回：" + me.long2datetime(params.row.cancelTime)));
                        }
                        spans.push(h("div", { style: styles }, text));

                        return h("div", { style: { padding: "10px 0px" } }, spans);
                    }
                }, {
                    title: '备注',
                    key: 'remark',
                    width: 280,
                    align: 'center'
                }, {
                    title: '系统备注',
                    key: 'sysRemark',
                    width: 180,
                    align: 'center'
                }, {
                    title: '操作',
                    key: 'state',
                    width: 180,
                    align: 'center',

                    fixed: 'left',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];
                        if (row.state == 0) {
                            btns.push(
                                h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "primary" }, on: { click: () => { this.sign(row); } } }, "签收"));
                            btns.push(
                                h("Button", {
                                    style: { marginRight: "5px" },
                                    props: { size: "small", type: "error" },
                                    on: {
                                        click: () => {
                                            this.waybillExpress = row;
                                            this.state = -2;
                                            this.showBack = true;
                                        }
                                    }
                                }, "取消"));
                            


                        }
                        if(row.state==1)
                        {
                            btns.push(
                                h("Button", {
                                    style: { marginRight: "5px" },
                                    props: { size: "small", type: "error" },
                                    on: {
                                        click: () => {
                                            this.waybillExpress = row;
                                            this.state = -1;
                                            this.showBack = true;
                                        }
                                    }
                                }, "未签收退回"));
                        }
                        var btnss=[];
                        btnss.push(h("Button", { style: { marginLeft: "5px" }, props: { size: "small", type: "primary" }, on: { click: () => { this.toRemark(row); } } }, "仓库备注"));

                        var divs=[];
                        divs.push(h("div", btns));
                        divs.push(h("div",{style:{marginTop:"10px"}}, btnss))
                        return h("div", divs);
                    }
                }

            ],
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
        }
    },
    props: [
        'show', 'waybill'
    ],
    mounted: function() {
        this.getList();

    },
    components: {
        CWaybillExpressBack,
        CWaybillExpressRemark

    },
    methods: {
        toRemark:function(obj) {
            this.waybillExpress = obj;
            this.showRemark = true;
        },
        remarkOk:function(rk)
        {
            this.waybillExpress.wareRemark=rk;
            this.showRemark=false;
        },
        cbtime: function(value) {
            if (value) {
                this.queryParams.btime = value[0];
                this.queryParams.etime = value[1];
            } else {
                this.queryParams.btime = "";
                this.queryParams.etime = "";
            }

        },

        cbstime: function(value) {
            if (value) {
                this.queryParams.bstime = value[0];
                this.queryParams.estime = value[1];
            } else {
                this.queryParams.bstime = "";
                this.queryParams.estime = "";
            }
        },
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {
            this.others = {};
            this.queryParams = {};
            this.getList();
        },
        showModal: function(val) {
            if (val) this.getList();

        },
        
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;

            me.loading = true;

            me.$http.post("/ware/waybillexpress/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.waybillExpresss = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.errorMessage(response);
                me.loading = false;
            });
        },
        ok: function() {
            this.$emit('ok');
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        cancel: function() {
            this.$emit('cancel')
        },
        sign: function(row) {
            var me = this;

            me.$Modal.confirm({
                title: "提示",
                content: "是否确定签收该包裹操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/waybillexpress/sign.action", { id: row.id }).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            me.getList();

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        }

    }
}
</script>
<style scoped>
</style>